<div class="ppv-label-indicator" *ngIf="showPPV && !parentShowingPPV">$ {{price}}</div>
